'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

interface ContactInfoItem {
  icon: string;
  titleAr: string;
  titleEn: string;
  content: string;
  link?: string;
  type?: 'phone' | 'email' | 'address';
}

const ContactInfo = () => {
  const { t } = useLanguage();

  const contactItems: ContactInfoItem[] = [
    {
      icon: 'PhoneIcon',
      titleAr: 'الهاتف',
      titleEn: 'Phone',
      content: '+966590041741',
      link: 'tel:+966590041741',
      type: 'phone',
    },
    {
      icon: 'EnvelopeIcon',
      titleAr: 'البريد الإلكتروني',
      titleEn: 'Email',
      content: 'info@ibdaa-elherfa.com',
      link: 'mailto:info@ibdaa-elherfa.com',
      type: 'email',
    },
    {
      icon: 'MapPinIcon',
      titleAr: 'العنوان',
      titleEn: 'Address',
      content: t('خميس مشيط - حي الخالدية', 'Khamis Mushait - Al Khalidiyah'),
      type: 'address',
    },
    {
      icon: 'ClockIcon',
      titleAr: 'ساعات العمل',
      titleEn: 'Working Hours',
      content: t('السبت - الخميس: 9:00 صباحاً - 6:00 مساءً', 'Saturday - Thursday: 9:00 AM - 6:00 PM'),
      type: 'address',
    },
  ];

  return (
    <div className="space-y-8">
      {/* Contact Information Cards */}
      <div className="space-y-4">
        <h2 className="text-2xl font-bold text-foreground font-amiri mb-6">
          {t('معلومات الاتصال', 'Contact Information')}
        </h2>
        {contactItems.map((item, index) => (
          <div
            key={index}
            className="bg-card rounded-lg p-6 border border-border hover:shadow-md transition-premium"
          >
            <div className="flex items-start gap-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10 text-primary flex-shrink-0">
                <Icon name={item.icon as any} size={24} />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-2">
                  {t(item.titleAr, item.titleEn)}
                </h3>
                {item.link ? (
                  <a
                    href={item.link}
                    className="text-muted-foreground hover:text-primary transition-premium inline-block"
                  >
                    {item.content}
                  </a>
                ) : (
                  <p className="text-muted-foreground">{item.content}</p>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Business Credentials */}
      <div className="bg-accent/10 rounded-lg p-6 border border-accent/20">
        <h3 className="text-lg font-semibold text-foreground mb-3 font-amiri">
          {t('معلومات الشركة', 'Company Information')}
        </h3>
        <div className="space-y-2 text-sm text-muted-foreground">
          <p>
            <span className="font-medium text-foreground">{t('السجل التجاري:', 'Commercial Registration:')}</span> 1009090220
          </p>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;